import { useState } from "react";
import { products } from "@/mocks/products";

export default function ProductSection() {
  const [activeProduct, setActiveProduct] = useState(products[0].id);

  return (
    <section
      id="product"
      className="relative w-full bg-background-50 border-t border-background-200/60"
    >
      {/* Full-width Collection Image */}
      <div className="relative w-full aspect-[4/3] md:aspect-[21/9] md:max-h-[560px] overflow-hidden bg-background-100">
        <img
          src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/24fc49d37ad2d3c5af697fedefbbb185.jpeg"
          alt="雷撃カゴ ラインナップ"
          title="雷撃カゴ ラインナップ"
          className="w-full h-full object-cover"
          style={{ objectPosition: "50% 60%" }}
        />
        {/* Subtle gradient overlay for depth */}
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent"></div>
      </div>

      {/* Content Area */}
      <div className="w-full px-6 md:px-10 max-w-[1600px] mx-auto py-16 md:py-24">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-[2px] bg-primary-500"></span>
              <span
                className="text-primary-500 text-xs tracking-[0.4em]"
                style={{ fontFamily: "var(--font-label)" }}
              >
                PRODUCT LINEUP
              </span>
            </div>
            <h4
              className="text-foreground-950 leading-[0.9]"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <a
                href="#product"
                className="hover:text-primary-500 transition-colors cursor-pointer"
              >
                <span className="block text-5xl md:text-7xl">雷撃カゴ</span>
                <span className="block text-3xl md:text-5xl italic text-primary-500 mt-2">
                  Product Line.
                </span>
              </a>
            </h4>
          </div>
          <p className="max-w-md text-foreground-600 text-sm md:text-base leading-relaxed">
            3Dプリント技術が生み出す、次世代カゴウキ。全モデル、緻密な流体解析と実釣テストを経て誕生しました。
          </p>
        </div>

        {/* Product Grid */}
        {/* 上段：カゴ4つ */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {products
            .filter((p) => p.id.startsWith("raigeki"))
            .map((product) => {
              const isActive = activeProduct === product.id;
              return (
                <div
                  key={product.id}
                  id={product.id}
                  onClick={() => setActiveProduct(product.id)}
                  className={`group relative overflow-hidden rounded-lg border transition-all duration-300 cursor-pointer ${
                    isActive
                      ? "border-primary-500 shadow-[0_0_30px_-5px_rgba(var(--primary-500),0.15)]"
                      : "border-background-200/60 hover:border-primary-500/40"
                  }`}
                >
                  {/* Product Image */}
                  <div className="relative w-full aspect-[4/5] overflow-hidden bg-background-100">
                    <img
                      src={product.image}
                      alt={product.name}
                      title={product.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      style={{ objectPosition: product.objectPosition }}
                    />
                    {/* Tag */}
                    <div className="absolute top-3 left-3">
                      <span
                        className={`text-[10px] tracking-[0.3em] px-3 py-1.5 rounded-full ${
                          product.accent
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-50/80 backdrop-blur text-foreground-900"
                        }`}
                      >
                        {product.tagline}
                      </span>
                    </div>
                    {/* Active indicator */}
                    {isActive && (
                      <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                        <i className="ri-check-line"></i>
                      </div>
                    )}
                  </div>

                  {/* Product Info */}
                  <div
                    className={`p-5 transition-colors duration-300 ${
                      isActive ? "bg-primary-500" : "bg-background-100"
                    }`}
                  >
                    <h5
                      className={`text-base md:text-lg mb-3 transition-colors duration-300 ${
                        isActive ? "text-background-50" : "text-foreground-950"
                      }`}
                      style={{ fontFamily: "var(--font-heading)" }}
                    >
                      {product.name}
                    </h5>
                    <div className="flex flex-wrap gap-2">
                      {product.size && (
                        <span
                          className={`text-xs tracking-[0.2em] px-2.5 py-1 rounded-full border transition-colors duration-300 ${
                            isActive
                              ? "border-background-50/40 text-background-50/80"
                              : "border-background-200/60 text-foreground-600"
                          }`}
                        >
                          {product.size}
                        </span>
                      )}
                      {product.weight && (
                        <span
                          className={`text-xs tracking-[0.2em] px-2.5 py-1 rounded-full border transition-colors duration-300 ${
                            isActive
                              ? "border-background-50/40 text-background-50/80"
                              : "border-background-200/60 text-foreground-600"
                          }`}
                        >
                          {product.weight}
                        </span>
                      )}
                      {product.color && (
                        <span
                          className={`text-xs tracking-[0.2em] px-2.5 py-1 rounded-full border transition-colors duration-300 ${
                            isActive
                              ? "border-background-50/40 text-background-50/80"
                              : "border-background-200/60 text-foreground-600"
                          }`}
                        >
                          {product.color}
                        </span>
                      )}
                      {product.spec && (
                        <span
                          className={`text-xs tracking-[0.2em] px-2.5 py-1 rounded-full border transition-colors duration-300 ${
                            isActive
                              ? "border-background-50/40 text-background-50/80"
                              : "border-background-200/60 text-foreground-600"
                          }`}
                        >
                          {product.spec}
                        </span>
                      )}
                    </div>
                    {product.price && (
                      <div className={`mt-3 pt-3 border-t border-dashed transition-colors duration-300 ${
                        isActive ? "border-background-50/30" : "border-background-200/60"
                      }`}>
                        <span
                          className={`text-lg md:text-xl transition-colors duration-300 ${
                            isActive ? "text-background-50" : "text-foreground-950"
                          }`}
                          style={{ fontFamily: "var(--font-heading)" }}
                        >
                          &yen;{product.price}
                        </span>
                        <span
                          className={`text-xs ml-1 transition-colors duration-300 ${
                            isActive ? "text-background-50/70" : "text-foreground-600"
                          }`}
                        >
                          （税込）
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>

        {/* 下段：天秤2つ */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {products
            .filter((p) => !p.id.startsWith("raigeki"))
            .map((product) => {
              const isActive = activeProduct === product.id;
              return (
                <div
                  key={product.id}
                  id={product.id}
                  onClick={() => setActiveProduct(product.id)}
                  className={`group relative overflow-hidden rounded-lg border transition-all duration-300 cursor-pointer ${
                    isActive
                      ? "border-primary-500 shadow-[0_0_30px_-5px_rgba(var(--primary-500),0.15)]"
                      : "border-background-200/60 hover:border-primary-500/40"
                  }`}
                >
                  {/* Product Image */}
                  <div className="relative w-full aspect-[4/5] overflow-hidden bg-background-100">
                    <img
                      src={product.image}
                      alt={product.name}
                      title={product.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      style={{ objectPosition: product.objectPosition }}
                    />
                    {/* Tag */}
                    <div className="absolute top-3 left-3">
                      <span
                        className={`text-[10px] tracking-[0.3em] px-3 py-1.5 rounded-full ${
                          product.accent
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-50/80 backdrop-blur text-foreground-900"
                        }`}
                      >
                        {product.tagline}
                      </span>
                    </div>
                    {/* Active indicator */}
                    {isActive && (
                      <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                        <i className="ri-check-line"></i>
                      </div>
                    )}
                  </div>

                  {/* Product Info */}
                  <div
                    className={`p-5 transition-colors duration-300 ${
                      isActive ? "bg-primary-500" : "bg-background-100"
                    }`}
                  >
                    <h5
                      className={`text-base md:text-lg mb-3 transition-colors duration-300 ${
                        isActive ? "text-background-50" : "text-foreground-950"
                      }`}
                      style={{ fontFamily: "var(--font-heading)" }}
                    >
                      {product.name}
                    </h5>
                    <div className="flex flex-wrap gap-2">
                      {product.size && (
                        <span
                          className={`text-xs tracking-[0.2em] px-2.5 py-1 rounded-full border transition-colors duration-300 ${
                            isActive
                              ? "border-background-50/40 text-background-50/80"
                              : "border-background-200/60 text-foreground-600"
                          }`}
                        >
                          {product.size}
                        </span>
                      )}
                      {product.weight && (
                        <span
                          className={`text-xs tracking-[0.2em] px-2.5 py-1 rounded-full border transition-colors duration-300 ${
                            isActive
                              ? "border-background-50/40 text-background-50/80"
                              : "border-background-200/60 text-foreground-600"
                          }`}
                        >
                          {product.weight}
                        </span>
                      )}
                      {product.color && (
                        <span
                          className={`text-xs tracking-[0.2em] px-2.5 py-1 rounded-full border transition-colors duration-300 ${
                            isActive
                              ? "border-background-50/40 text-background-50/80"
                              : "border-background-200/60 text-foreground-600"
                          }`}
                        >
                          {product.color}
                        </span>
                      )}
                      {product.spec && (
                        <span
                          className={`text-xs tracking-[0.2em] px-2.5 py-1 rounded-full border transition-colors duration-300 ${
                            isActive
                              ? "border-background-50/40 text-background-50/80"
                              : "border-background-200/60 text-foreground-600"
                          }`}
                        >
                          {product.spec}
                        </span>
                      )}
                    </div>
                    {product.price && (
                      <div className={`mt-3 pt-3 border-t border-dashed transition-colors duration-300 ${
                        isActive ? "border-background-50/30" : "border-background-200/60"
                      }`}>
                        <span
                          className={`text-lg md:text-xl transition-colors duration-300 ${
                            isActive ? "text-background-50" : "text-foreground-950"
                          }`}
                          style={{ fontFamily: "var(--font-heading)" }}
                        >
                          &yen;{product.price}
                        </span>
                        <span
                          className={`text-xs ml-1 transition-colors duration-300 ${
                            isActive ? "text-background-50/70" : "text-foreground-600"
                          }`}
                        >
                          （税込）
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-14 flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 border-t border-background-200/60 pt-8">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-shopping-bag-3-line text-xl"></i>
              </div>
              <div>
                <div
                  className="text-foreground-950 text-lg md:text-xl"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  オンラインショップはこちら
                </div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1">
                  各モデルの詳細や販売についてはお気軽にお問い合わせください。
                </div>
              </div>
            </div>
            <a
              href="/how-to#how-to-use"
              className="flex items-center gap-4 group cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
                <i className="ri-book-open-line text-xl"></i>
              </div>
              <div>
                <div
                  className="text-foreground-950 text-base md:text-lg group-hover:text-primary-500 transition-colors"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  雷撃カゴと天秤の使い方はこちら
                </div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1">
                  セッティングから実釣まで、基本をマスターしましょう。
                </div>
              </div>
            </a>
          </div>
          <a
            href="https://raigeki-hayabusa.stores.jp"
            target="_blank"
            rel="noopener noreferrer"
            className="self-start inline-flex items-center gap-3 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-xs tracking-[0.3em] whitespace-nowrap hover:bg-primary-600 transition cursor-pointer"
            style={{ fontFamily: "var(--font-label)" }}
          >
            公式オンラインショップ
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}